import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
    StarFullIcon,
    StarHalfIcon,
} from 'wanderu-components';
import { capitalize } from 'wanderu-css';
import { range } from 'wanderu-utils';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './StarRating.scss';

function Star(props) {
    const {
        index,
        rating,
        onClick,
        hoverEffects,
        starClassName,
        starClassNames,
    } = props;

    const starProps = {
        className: classNames(
            starClassName,
            starClassNames.base,
            styles.star,
            {
                [styles.isSelected]: rating >= index || index - rating < 1,
                [starClassNames.isSelected]: rating >= index || index - rating < 1,
            },
            styles[`hoverEffects${capitalize(hoverEffects)}`],
        ),
        onClick: () => onClick(index),
    };

    return index - rating < 1 && index - rating > 0
        ? <StarHalfIcon {...starProps} />
        : <StarFullIcon {...starProps} />;
}

Star.propTypes = {
    hoverEffects: PropTypes.oneOf(['none', 'default']),
    index: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
    rating: PropTypes.number.isRequired,
    starClassName: PropTypes.string,
    starClassNames: PropTypes.shape({
        base: PropTypes.string,
        isSelected: PropTypes.string,
    }),
};

function StarRating(props) {
    const {
        className = '',
        hoverEffects = 'default',
        id,
        maxRating = 5,
        onClick = () => undefined,
        rating = -1,
        starClassName = '',
        starClassNames = {},
    } = props;

    return (
        <span
            aria-labelledby={id}
            className={classNames(
                className,
                styles.stars,
                styles[`hoverEffects${capitalize(hoverEffects)}`],
            )}
        >
            {range(maxRating).map((item, index) => (
                <Star
                    hoverEffects={hoverEffects}
                    index={index}
                    key={item}
                    onClick={onClick}
                    rating={rating}
                    starClassName={starClassName}
                    starClassNames={starClassNames}
                />
            ))}
        </span>
    );
}

StarRating.propTypes = {
    className: PropTypes.string,
    hoverEffects: PropTypes.oneOf(['none', 'default']),
    id: PropTypes.string.isRequired,
    maxRating: PropTypes.number,
    onClick: PropTypes.func,
    rating: PropTypes.number,
    starClassName: PropTypes.string,
    starClassNames: PropTypes.shape({
        base: PropTypes.string,
        isSelected: PropTypes.string,
    }),
};

export {
    Star,
    StarRating,
};
export default StarRating;
